import { getTablerIconByName, getLucideIconByName } from "@/components/feature/MediaPicker";

type IconRendererProps = {
  iconUrl?: string | null;
  fallbackIcon?: string;
  color?: string;
  size?: number;
  className?: string;
};

const isImageUrl = (value: string) => {
  const lower = value.toLowerCase();
  return lower.endsWith(".png") || lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".gif") || lower.endsWith(".webp") || lower.endsWith(".svg");
};

export default function IconRenderer({ iconUrl, fallbackIcon, color, size = 18, className = "" }: IconRendererProps) {
  if (!iconUrl) {
    if (fallbackIcon) {
      return <i className={`${fallbackIcon} ${className}`} style={{ color }} />;
    }
    return null;
  }

  const trimmed = iconUrl.trim();

  // 1. Tabler Icons
  if (trimmed.startsWith("icon:")) {
    const iconName = trimmed.replace("icon:", "");
    const IconComponent = getTablerIconByName(iconName);
    if (IconComponent) {
      return <IconComponent size={size} className={className} color={color} />;
    }
  }

  // 1b. Lucide Icons
  if (trimmed.startsWith("lucide:")) {
    const iconName = trimmed.replace("lucide:", "");
    const IconComponent = getLucideIconByName(iconName);
    if (IconComponent) {
      return <IconComponent size={size} className={className} color={color} />;
    }
  }

  // 2. Raw SVG code
  if (trimmed.startsWith("<svg") || trimmed.includes("<svg")) {
    return (
      <span
        className={`inline-block ${className}`}
        style={{ width: size, height: size, color, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        dangerouslySetInnerHTML={{ __html: trimmed }}
      />
    );
  }

  // 3. Remix Icons class name
  if (trimmed.startsWith("ri-")) {
    return <i className={`${trimmed} ${className}`} style={{ color, fontSize: size }} />;
  }

  // 4. Image URLs
  if (isImageUrl(trimmed)) {
    return <img src={trimmed} alt="icon" className={`${className} object-contain`} style={{ width: size, height: size }} />;
  }

  // 5. General Fallback
  if (fallbackIcon) {
    return <i className={`${fallbackIcon} ${className}`} style={{ color }} />;
  }

  // 6. Otherwise if it's plain text, just render text or null
  return null;
}
